import styled from 'styled-components';

export const GoogleMapZone = styled.div`
  position: relative;

  .center {
    display: block;
    margin: 0 auto;
  }

  > div {
    min-height: 85vh;
    background-color: white;

    &.list {
      padding-top: 3vh;
      padding-bottom: 3vh;
      max-height: 90vh;
      overflow-y: auto;

      .selected {
        border: 1px solid black;
      }
    }
  }
`;
